export default __webpack_public_path__ + "static/the-negotiator-awards-2022-176d1f2e27a15909e66f2eb08c6312ff.webp";